import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../wayfinder'
import async from './async'
/**
* @see \App\Http\Controllers\SessionController::create
* @see app/Http/Controllers/SessionController.php:619
* @route 'https://app.pokor.dev/sessions/create'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: 'https://app.pokor.dev/sessions/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SessionController::create
* @see app/Http/Controllers/SessionController.php:619
* @route 'https://app.pokor.dev/sessions/create'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SessionController::create
* @see app/Http/Controllers/SessionController.php:619
* @route 'https://app.pokor.dev/sessions/create'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SessionController::create
* @see app/Http/Controllers/SessionController.php:619
* @route 'https://app.pokor.dev/sessions/create'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SessionController::store
* @see app/Http/Controllers/SessionController.php:658
* @route 'https://app.pokor.dev/sessions'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: 'https://app.pokor.dev/sessions',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\SessionController::store
* @see app/Http/Controllers/SessionController.php:658
* @route 'https://app.pokor.dev/sessions'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SessionController::store
* @see app/Http/Controllers/SessionController.php:658
* @route 'https://app.pokor.dev/sessions'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\SessionController::lookup
* @see app/Http/Controllers/SessionController.php:1827
* @route 'https://app.pokor.dev/sessions/lookup/{slug}'
*/
export const lookup = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: lookup.url(args, options),
    method: 'get',
})

lookup.definition = {
    methods: ["get","head"],
    url: 'https://app.pokor.dev/sessions/lookup/{slug}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SessionController::lookup
* @see app/Http/Controllers/SessionController.php:1827
* @route 'https://app.pokor.dev/sessions/lookup/{slug}'
*/
lookup.url = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { slug: args }
    }

    if (Array.isArray(args)) {
        args = {
            slug: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        slug: args.slug,
    }

    return lookup.definition.url
            .replace('{slug}', parsedArgs.slug.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SessionController::lookup
* @see app/Http/Controllers/SessionController.php:1827
* @route 'https://app.pokor.dev/sessions/lookup/{slug}'
*/
lookup.get = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: lookup.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SessionController::lookup
* @see app/Http/Controllers/SessionController.php:1827
* @route 'https://app.pokor.dev/sessions/lookup/{slug}'
*/
lookup.head = (args: { slug: string | number } | [slug: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: lookup.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SessionController::join
* @see app/Http/Controllers/SessionController.php:479
* @route 'https://app.pokor.dev/{session}/join'
*/
export const join = (args: { session: string | number | { slug: string | number } } | [session: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: join.url(args, options),
    method: 'post',
})

join.definition = {
    methods: ["post"],
    url: 'https://app.pokor.dev/{session}/join',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\SessionController::join
* @see app/Http/Controllers/SessionController.php:479
* @route 'https://app.pokor.dev/{session}/join'
*/
join.url = (args: { session: string | number | { slug: string | number } } | [session: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { session: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { session: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            session: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        session: typeof args.session === 'object'
        ? args.session.slug
        : args.session,
    }

    return join.definition.url
            .replace('{session}', parsedArgs.session.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SessionController::join
* @see app/Http/Controllers/SessionController.php:479
* @route 'https://app.pokor.dev/{session}/join'
*/
join.post = (args: { session: string | number | { slug: string | number } } | [session: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: join.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\SessionController::retrospective
* @see app/Http/Controllers/SessionController.php:597
* @route 'https://app.pokor.dev/{session}/retrospective'
*/
export const retrospective = (args: { session: string | number | { slug: string | number } } | [session: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: retrospective.url(args, options),
    method: 'get',
})

retrospective.definition = {
    methods: ["get","head"],
    url: 'https://app.pokor.dev/{session}/retrospective',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SessionController::retrospective
* @see app/Http/Controllers/SessionController.php:597
* @route 'https://app.pokor.dev/{session}/retrospective'
*/
retrospective.url = (args: { session: string | number | { slug: string | number } } | [session: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { session: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { session: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            session: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        session: typeof args.session === 'object'
        ? args.session.slug
        : args.session,
    }

    return retrospective.definition.url
            .replace('{session}', parsedArgs.session.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SessionController::retrospective
* @see app/Http/Controllers/SessionController.php:597
* @route 'https://app.pokor.dev/{session}/retrospective'
*/
retrospective.get = (args: { session: string | number | { slug: string | number } } | [session: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: retrospective.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SessionController::retrospective
* @see app/Http/Controllers/SessionController.php:597
* @route 'https://app.pokor.dev/{session}/retrospective'
*/
retrospective.head = (args: { session: string | number | { slug: string | number } } | [session: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: retrospective.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\SessionController::show
* @see app/Http/Controllers/SessionController.php:65
* @route 'https://app.pokor.dev/{session}'
*/
export const show = (args: { session: string | number | { slug: string | number } } | [session: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: 'https://app.pokor.dev/{session}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\SessionController::show
* @see app/Http/Controllers/SessionController.php:65
* @route 'https://app.pokor.dev/{session}'
*/
show.url = (args: { session: string | number | { slug: string | number } } | [session: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { session: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'slug' in args) {
        args = { session: args.slug }
    }

    if (Array.isArray(args)) {
        args = {
            session: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        session: typeof args.session === 'object'
        ? args.session.slug
        : args.session,
    }

    return show.definition.url
            .replace('{session}', parsedArgs.session.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\SessionController::show
* @see app/Http/Controllers/SessionController.php:65
* @route 'https://app.pokor.dev/{session}'
*/
show.get = (args: { session: string | number | { slug: string | number } } | [session: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\SessionController::show
* @see app/Http/Controllers/SessionController.php:65
* @route 'https://app.pokor.dev/{session}'
*/
show.head = (args: { session: string | number | { slug: string | number } } | [session: string | number | { slug: string | number } ] | string | number | { slug: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

const sessions = {
    create: Object.assign(create, create),
    store: Object.assign(store, store),
    lookup: Object.assign(lookup, lookup),
    join: Object.assign(join, join),
    async: Object.assign(async, async),
    retrospective: Object.assign(retrospective, retrospective),
    show: Object.assign(show, show),
}

export default sessions